import { FaShopify } from 'react-icons/fa'
import { BiEditAlt } from 'react-icons/bi'
import { IoMdHelp } from 'react-icons/io'
import { FaStore } from 'react-icons/fa'
import { FaWikipediaW } from 'react-icons/fa'
import { FaBook } from 'react-icons/fa'

import './header.css'
import UserAppContext from '../../hook/UserAppContext'

const Header = () => {
      
      const {user, dataApp} = UserAppContext()
      const {infordata, banners} = user.user

      return (
            <div className="header_content">
                  <div className="header_aside">
                        <div className="header_user">
                              <div className="user_avatar">
                                    <img src={infordata.data || infordata.avatar === '' ? dataApp.info.avatar : infordata.avatar} alt={infordata.data || infordata.name === '' ? dataApp.info.name : infordata.name} />
                              </div>
                              <h2>{infordata.data || infordata.name === '' ? dataApp.info.name : infordata.name}</h2>
                              <p>Custom Xat.Me</p>
                        </div>
                        <div className="header_xat">
                              <a href="https://xat.com/trade" target="_blank" rel="noreferrer">
                                    <FaShopify />
                                    <span>Trade</span>
                              </a>
                              <a href="https://xat.com/editme" target="_blank" rel="noreferrer">
                                    <BiEditAlt />
                                    <span>Edit</span>
                              </a>
                              <a href="https://xat.com/help" target="_blank" rel="noreferrer">
                                    <IoMdHelp />
                                    <span>Help</span>
                              </a>
                              <a href="https://xat.com/store" target="_blank" rel="noreferrer">
                                    <FaStore />
                                    <span>Store</span>
                              </a>
                              <a href="https://xat.wiki" target="_blank" rel="noreferrer">
                                    <FaWikipediaW />
                                    <span>Wiki</span>
                              </a>
                              <a href="https://forum.xat.com" target="_blank" rel="noreferrer">
                                    <FaBook />
                                    <span>Forum</span>
                              </a>
                        </div>
                  </div>
                  <div className="header_banner">
                        <div className="banner_content">
                              <img src={banners.data ? dataApp.banner.image : banners[0].image} alt={banners.data ? dataApp.banner.title : banners[0].title} />
                        </div>
                  </div>
            </div>
      )
}

export default Header